import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import VueJsonp from 'vue-jsonp'

Vue.config.productionTip = false
Vue.use(VueJsonp)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

